"use strict";
/**
 * =================================
 * 余白 設定
 * =================================
 */
// 4 ~ 120 までの4の倍数
const spacing = [...Array(121)]
    .map((_, i) => i + 1)
    .filter((v) => v % 4 === 0)
    .reduce((result, value) => (Object.assign(Object.assign({}, result), { [value]: `${value}px` })), {
    0: '0px',
    1: '1px',
    2: '1px',
    3: '1px',
});
module.exports = {
    spacing,
};
